(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__pbCartInit) return;
    window.__pbCartInit = true;

    var body = document.body;
    var DEBOUNCE_MS = 300;
    var timers = {};      // line key -> debounce timeout id
    var pendingQty = {};  // line key -> latest optimistic quantity
    var drawerDirty = false;

    function pageSectionId() {
      var el = document.querySelector('[data-cart-section]');
      return el ? el.getAttribute('data-cart-section') : null;
    }
    function drawerIsOpen() { return body.classList.contains('cart-open'); }

    function closeDrawer() { body.classList.remove('cart-open'); }

    // Open the drawer. If it went stale from an edit made while it was closed,
    // lazily refresh it BEFORE showing, so there is no stale->fresh flash.
    function openDrawer() {
      if (!drawerDirty) { body.classList.add('cart-open'); return; }
      drawerDirty = false;
      fetch(window.location.pathname + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var el = document.getElementById('shopify-section-cart-drawer');
          if (el && sections && sections['cart-drawer'] != null) el.outerHTML = sections['cart-drawer'];
        })
        .catch(function () {})
        .then(function () { body.classList.add('cart-open'); });
    }

    // Re-render only what is VISIBLE on a qty/remove mutation. On /cart with the
    // drawer closed this renders the page alone and defers the hidden drawer.
    function mutationSections() {
      var ids = [];
      if (drawerIsOpen()) ids.push('cart-drawer');
      var pid = pageSectionId();
      if (pid) ids.push(pid);
      if (ids.length === 0) ids.push('cart-drawer');
      if (ids.indexOf('cart-drawer') === -1) drawerDirty = true;
      return ids.join(',');
    }
    // Add always re-renders the drawer (it opens) plus the page when present.
    function addSections() {
      var ids = ['cart-drawer'];
      var pid = pageSectionId();
      if (pid) ids.push(pid);
      return ids.join(',');
    }

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    }
    function syncCountFromDrawer() {
      var src = document.querySelector('[data-cart-count-display]');
      if (src) setCount(src.textContent.trim());
    }

    function swapSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var el = document.getElementById('shopify-section-' + id);
        if (el && sections[id] != null) el.outerHTML = sections[id];
      });
    }

    // Apply a cart AJAX response: swap rendered sections, sync the badge from the
    // JSON item_count when present (else from the freshly rendered drawer), refresh recs.
    function applyCart(state) {
      if (state && state.sections) swapSections(state.sections);
      if (state && typeof state.item_count === 'number') setCount(state.item_count);
      else syncCountFromDrawer();
      loadRecommendations();
    }

    // On a failed mutation, re-pull the visible sections so an optimistic number
    // can never be left disagreeing with the real cart.
    function resyncVisible() {
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(mutationSections()), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sections) { swapSections(sections); syncCountFromDrawer(); })
        .catch(function () {});
    }

    // Dynamic cross-sell: re-render the cart page's cross-sell row from the product
    // recommendations endpoint (Search & Discovery), keyed to the first cart item.
    // Falls back silently to the server-rendered collection cards when none returned.
    function loadRecommendations() {
      var host = document.querySelector('[data-cart-recommendations]');
      if (!host) return;
      var pid = host.getAttribute('data-product-id');
      if (!pid) return;
      var url = '/recommendations/products?product_id=' + encodeURIComponent(pid) +
        '&intent=related&limit=3&section_id=main-cart';
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-xsell-row]');
          var live = document.querySelector('[data-xsell-row]');
          if (fresh && live && fresh.children.length) live.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }

    function postJSON(url, payload) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    }

    function lineByKey(key) {
      return document.querySelector('[data-line-key="' + key + '"]');
    }

    // Debounced quantity change (last-value-wins). The in-flight (.is-pending)
    // state is applied only when the request actually fires, so rapid +/- clicks
    // coalesce into one request while the controls stay live during the window.
    function scheduleChange(key) {
      if (timers[key]) clearTimeout(timers[key]);
      timers[key] = setTimeout(function () { flushChange(key); }, DEBOUNCE_MS);
    }
    function flushChange(key) {
      delete timers[key];
      var qty = pendingQty[key];
      delete pendingQty[key];
      if (qty == null) return;
      var lineEl = lineByKey(key);
      if (lineEl) lineEl.classList.add('is-pending');
      postJSON('/cart/change.js', { id: key, quantity: qty, sections: mutationSections(), sections_url: window.location.pathname })
        .then(applyCart)
        .catch(resyncVisible);
    }
    function removeLine(key) {
      if (timers[key]) { clearTimeout(timers[key]); delete timers[key]; }
      delete pendingQty[key];
      var lineEl = lineByKey(key);
      if (lineEl) lineEl.classList.add('is-pending');
      postJSON('/cart/change.js', { id: key, quantity: 0, sections: mutationSections(), sections_url: window.location.pathname })
        .then(applyCart)
        .catch(resyncVisible);
    }

    // Shared add path. Returns a promise resolving to the cart state on success,
    // or { error: true, status, description } on an add.js error (e.g. stock limit),
    // so callers (cross-sell quick-add, quick-add modal) can react. Reused everywhere.
    function addVariant(id, quantity) {
      return postJSON('/cart/add.js', { id: id, quantity: quantity || 1, sections: addSections(), sections_url: window.location.pathname })
        .then(function (state) {
          if (state && (state.status || state.errors)) {
            return { error: true, status: state.status, description: state.description || state.message };
          }
          applyCart(state);
          openDrawer();
          return state;
        })
        .catch(function () { return { error: true }; });
    }

    // Multi-item add (FBT "add all"). Same Section Rendering + open-drawer path as
    // addVariant, but posts an items[] array in a single /cart/add.js call.
    function addItems(items) {
      if (!items || !items.length) return Promise.resolve({ error: true });
      return postJSON('/cart/add.js', { items: items, sections: addSections(), sections_url: window.location.pathname })
        .then(function (state) {
          if (state && (state.status || state.errors)) {
            return { error: true, status: state.status, description: state.description || state.message };
          }
          applyCart(state);
          openDrawer();
          return state;
        })
        .catch(function () { return { error: true }; });
    }

    // Open / close + qty + remove + cross-sell add (delegated, survives re-renders)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-overlay]')) { e.preventDefault(); closeDrawer(); return; }

      var xadd = e.target.closest('[data-xsell-add]');
      if (xadd) { e.preventDefault(); var vid = xadd.getAttribute('data-variant-id'); if (vid) addVariant(vid); return; }

      var rem = e.target.closest('[data-line-remove]');
      if (rem) {
        e.preventDefault();
        var rEl = e.target.closest('[data-line-key]');
        if (rEl) removeLine(rEl.getAttribute('data-line-key'));
        return;
      }

      var up = e.target.closest('[data-qty-up]');
      var down = e.target.closest('[data-qty-down]');
      if (up || down) {
        e.preventDefault();
        var lineEl = e.target.closest('[data-line-key]');
        if (!lineEl) return;
        var key = lineEl.getAttribute('data-line-key');
        var nEl = lineEl.querySelector('[data-qty-n]');
        var current = parseInt(nEl ? nEl.textContent : '1', 10) || 1;
        var qty = up ? current + 1 : current - 1;
        if (qty < 0) qty = 0;
        if (nEl) nEl.textContent = qty;
        pendingQty[key] = qty;
        scheduleChange(key);
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Intercept every product add-to-cart form -> AJAX add -> open drawer (the feedback)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');
      var fd = new FormData(form);
      fd.append('sections', addSections());
      fd.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (state) { applyCart(state); openDrawer(); })
        .catch(function () {})
        .then(function () { if (btn) btn.removeAttribute('disabled'); });
    });

    // Persist the cart note on change (no re-render needed)
    document.addEventListener('change', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (!note) return;
      postJSON('/cart/update.js', { note: note.value }).catch(function () {});
    });

    // Public API so other components (e.g. the quick-add modal) reuse this one
    // add -> Section-Rendering swap -> open-drawer path instead of duplicating it.
    window.PBCart = { open: openDrawer, addVariant: addVariant, addItems: addItems };

    // Initial dynamic cross-sell load on the cart page
    if (document.readyState !== 'loading') loadRecommendations();
    else document.addEventListener('DOMContentLoaded', loadRecommendations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.querySelectorAll('.main-article .js-copy-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var url = link.getAttribute('data-copy-url');
      if (!navigator.clipboard || !url) return;
      e.preventDefault();
      navigator.clipboard.writeText(url).then(function () {
        link.setAttribute('aria-label', 'Link copied');
        link.classList.add('is-copied');
        setTimeout(function () {
          link.setAttribute('aria-label', 'Copy link');
          link.classList.remove('is-copied');
        }, 1600);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.documentElement.classList.add('js');

  document.querySelectorAll('[data-dd]').forEach(function (dd) {
    var btn = dd.querySelector('[data-ddbtn]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = dd.classList.contains('open');
      document.querySelectorAll('[data-dd]').forEach(function (d) { d.classList.remove('open'); });
      if (!wasOpen) dd.classList.add('open');
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('[data-dd]').forEach(function (d) { d.classList.remove('open'); });
  });
  document.querySelectorAll('.dd-panel').forEach(function (p) {
    p.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  document.querySelectorAll('[data-pb-filters]').forEach(function (form) {
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  (function () {
    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    var banner = document.querySelector('.contact-card .form-banner.ok');
    if (banner) {
      banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    if (window.__pbSearchSortInit) return;
    window.__pbSearchSortInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-search-ddbtn]');
      if (btn) {
        e.stopPropagation();
        var dd = btn.closest('[data-search-dd]');
        var wasOpen = dd.classList.contains('open');
        document.querySelectorAll('[data-search-dd]').forEach(function (d) { d.classList.remove('open'); });
        if (!wasOpen) dd.classList.add('open');
        return;
      }
      document.querySelectorAll('[data-search-dd]').forEach(function (d) { d.classList.remove('open'); });
    });

    document.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-search-sort-form] input[type="radio"]');
      if (radio && radio.form) radio.form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-faq"]) return;
  try {
    
  document.querySelectorAll('.faq .faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var list = item.parentElement;
      var wasOpen = item.classList.contains('open');
      list.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        var btn = i.querySelector('.faq-q');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-fbt"]) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.pb-fbt');
    roots.forEach(function (root) {
      var box = root.querySelector('[data-pb-fbt]');
      if (!box || box.__pbFbtInit) return;
      box.__pbFbtInit = true;

      var CURRENCY = root.getAttribute('data-currency') || 'USD';
      var nowEl = box.querySelector('[data-fbt-now]');
      var countEl = box.querySelector('[data-fbt-count]');
      var addBtn = box.querySelector('[data-fbt-add]');
      var items = box.querySelectorAll('[data-fbt-item]');

      function money(cents) {
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      function checkedItems() {
        var out = [];
        items.forEach(function (it) {
          var on = it.getAttribute('data-locked') === '1' || it.getAttribute('data-on') === '1';
          if (on) out.push(it);
        });
        return out;
      }

      function recalc() {
        var sel = checkedItems();
        var sum = 0;
        sel.forEach(function (it) { sum += parseInt(it.getAttribute('data-price'), 10) || 0; });
        if (nowEl) nowEl.textContent = money(sum);
        var n = sel.length;
        if (countEl) countEl.innerHTML = '&middot; ' + n + (n === 1 ? ' item' : ' items');
      }

      box.querySelectorAll('.fbt-check[role="checkbox"]').forEach(function (c) {
        function toggle() {
          var it = c.closest('[data-fbt-item]');
          var on = it.getAttribute('data-on') === '1';
          it.setAttribute('data-on', on ? '0' : '1');
          c.classList.toggle('on', !on);
          c.setAttribute('aria-checked', String(!on));
          recalc();
        }
        c.addEventListener('click', toggle);
        c.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var api = (window.PBCart && window.PBCart.addItems) ? window.PBCart.addItems : null;
          if (!api) return;
          var payload = [];
          checkedItems().forEach(function (it) {
            if (it.getAttribute('data-available') === 'false') return;
            var vid;
            if (it.getAttribute('data-locked') === '1') {
              var pid = document.querySelector('[data-pb-id]');
              vid = (pid && pid.value) ? pid.value : it.getAttribute('data-variant-id');
            } else {
              vid = it.getAttribute('data-variant-id');
            }
            if (vid) payload.push({ id: vid, quantity: 1 });
          });
          if (!payload.length) return;
          var orig = addBtn.innerHTML;
          addBtn.setAttribute('disabled', '');
          addBtn.textContent = 'Adding...';
          api(payload).then(function () {
            addBtn.removeAttribute('disabled');
            addBtn.innerHTML = orig;
          });
        });
      }

      recalc();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-final-cta"]) return;
  try {
    
  document.querySelectorAll('[data-pb-final-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var bb = document.querySelector('.buybox');
      if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-main"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pb-product]');
    if (!root) return;

    var dataEl = root.querySelector('[data-pb-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-pb-id]');
    var priceEl = root.querySelector('[data-pb-price]');
    var compareEl = root.querySelector('[data-pb-compare]');
    var saveEl = root.querySelector('[data-pb-save]');
    var atc = root.querySelector('[data-pb-atc]');
    var atcText = root.querySelector('[data-pb-atc-text]');
    var form = root.querySelector('form');
    var sticky = document.querySelector('[data-pb-sticky]');
    var stickyPrice = sticky ? sticky.querySelector('[data-pb-sticky-price]') : null;

    function selectedValues() {
      var vals = [];
      root.querySelectorAll('.opt-pill.active').forEach(function (p) {
        vals[parseInt(p.getAttribute('data-pb-opt'), 10) - 1] = p.getAttribute('data-pb-value');
      });
      return vals;
    }

    function findVariant(vals) {
      return variants.filter(function (v) {
        if (v.options.length !== vals.length) return false;
        return v.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    }

    function update() {
      var v = findVariant(selectedValues());
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (v.compare) {
        compareEl.textContent = v.compare;
        compareEl.hidden = false;
        saveEl.textContent = 'You save ' + v.save;
        saveEl.hidden = false;
      } else {
        compareEl.hidden = true;
        saveEl.hidden = true;
      }
      if (v.available) {
        atc.disabled = false;
        atcText.textContent = atc.getAttribute('data-add-label');
      } else {
        atc.disabled = true;
        atcText.textContent = atc.getAttribute('data-sold-label');
      }
      if (v.media_id) {
        var gal = document.querySelector('[data-pb-gallery]');
        if (gal) {
          var mid = String(v.media_id);
          // Only re-point the gallery if this variant's media actually exists as a
          // slide. If a variant has no image (or its media is missing), keep the
          // current image rather than blanking the gallery.
          var target = gal.querySelector('.gallery-slide[data-media-id="' + mid + '"]');
          if (target) {
            gal.querySelectorAll('.gallery-slide').forEach(function (s) {
              s.classList.toggle('active', s.getAttribute('data-media-id') === mid);
            });
            gal.querySelectorAll('.thumb').forEach(function (t) {
              t.classList.toggle('active', t.getAttribute('data-thumb') === mid);
            });
          }
        }
      }
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    root.querySelectorAll('.opt-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var pos = pill.getAttribute('data-pb-opt');
        root.querySelectorAll('.opt-pill[data-pb-opt="' + pos + '"]').forEach(function (x) {
          x.classList.remove('active');
        });
        pill.classList.add('active');
        var chosen = root.querySelector('[data-pb-chosen="' + pos + '"]');
        if (chosen) chosen.textContent = pill.getAttribute('data-pb-value');
        update();
      });
    });

    var qty = root.querySelector('[data-pb-qty]');
    var qMinus = root.querySelector('[data-pb-qminus]');
    var qPlus = root.querySelector('[data-pb-qplus]');
    if (qMinus) qMinus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (qPlus) qPlus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    if (qty) qty.addEventListener('input', function () { qty.value = qty.value.replace(/[^0-9]/g, '') || '1'; });

    if (sticky) {
      var sAdd = sticky.querySelector('[data-pb-sticky-add]');
      if (sAdd && form) {
        sAdd.addEventListener('click', function () {
          if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        });
      }
    }

    var gallery = document.querySelector('[data-pb-gallery]');
    if (gallery) {
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-thumb');
          gallery.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
          t.classList.add('active');
          gallery.querySelectorAll('.gallery-slide').forEach(function (s) {
            s.classList.toggle('active', s.getAttribute('data-media-id') === id);
          });
        });
      });
    }

    var pdp = document.querySelector('.pdp');
    if (sticky && pdp) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('show', pdp.getBoundingClientRect().bottom < 0);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search"]) return;
  try {
    
  (function () {
    if (window.__pbPredictiveInit) return;
    window.__pbPredictiveInit = true;

    var panel = document.querySelector('[data-search-panel]');
    var overlay = document.querySelector('[data-search-overlay]');
    if (!panel || !overlay) return;
    var input = panel.querySelector('[data-predictive-input]');
    var region = panel.querySelector('[data-predictive-results]');
    var body = document.body;
    var emptyHTML = region ? region.innerHTML : '';
    var lastTrigger = null;
    var timer = null;
    var controller = null;

    function openPanel(trigger) {
      lastTrigger = trigger || null;
      body.classList.add('search-open');
      panel.setAttribute('aria-hidden', 'false');
      setTimeout(function () { if (input) input.focus(); }, 340);
    }
    function closePanel() {
      body.classList.remove('search-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('is-searching');
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    function restoreEmpty() {
      if (region) region.innerHTML = emptyHTML;
    }

    function runSearch(q) {
      if (controller) controller.abort();
      controller = (window.AbortController) ? new AbortController() : null;
      panel.classList.add('is-searching');
      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'text/html' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          panel.classList.remove('is-searching');
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-predictive-results]');
          if (fresh && region) region.innerHTML = fresh.innerHTML;
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') panel.classList.remove('is-searching'); });
    }

    function onType() {
      var q = (input.value || '').trim();
      if (timer) clearTimeout(timer);
      if (q.length < 2) { if (controller) controller.abort(); panel.classList.remove('is-searching'); restoreEmpty(); return; }
      timer = setTimeout(function () { runSearch(q); }, 200);
    }

    // Open from the header search icon (delegated; header is a separate section)
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-search-toggle]');
      if (toggle) { e.preventDefault(); openPanel(toggle); return; }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); closePanel(); }
    });
    overlay.addEventListener('click', closePanel);
    if (input) input.addEventListener('input', onType);

    // Esc + focus trap while open
    document.addEventListener('keydown', function (e) {
      if (!body.classList.contains('search-open')) return;
      if (e.key === 'Escape') { closePanel(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
